// extracted by mini-css-extract-plugin
module.exports = {"blockInstitutes":"FZ2pp","blockRecommendations":"_5fRpM"};